export default function mixin(Base, ...mixins) {
    return mixins.reduce((mix, applyMixin) => applyMixin(mix), Base);
}
//# sourceMappingURL=mixin.js.map